import * as React from 'react'

const IconUp = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-up_svg__a' d='M0 0h12v20H0z' />
    </defs>
    <g transform='rotate(-90 10 8)' fill='none' fillRule='evenodd'>
      <mask id='icon-up_svg__b' fill='#fff'>
        <use xlinkHref='#icon-up_svg__a' />
      </mask>
      <path
        d='M1.592 20a1.62 1.62 0 0 1-1.126-.448 1.488 1.488 0 0 1 0-2.164L8.156 10 .465 2.612a1.488 1.488 0 0 1 0-2.164 1.64 1.64 0 0 1 2.252 0l8.815 8.47a1.488 1.488 0 0 1 0 2.164l-8.815 8.47A1.62 1.62 0 0 1 1.592 20'
        fill='#00B2E3'
        mask='url(#icon-up_svg__b)'
      />
    </g>
  </svg>
)

export default IconUp
